import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logo, googlePlay, appStore, DRYawnSignup, DRYawnFreetrial, DRYawnFullBody, DRYawnTitle } from "../../Assets/images";

import "./style.css";

const AuthLayout = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <section className={`fullPageBg ${props.pagename === "signup" && 'py-3'}`}>
        <div className={`d-flex align-items-center justify-content-between w-100 px-5 py-3 ${props.pagename !== "signup" && 'd-none'}`}>
          <img src={logo} alt="Logo Horizontal" style={{ maxWidth: 120 }} className="img-fluid w-100" />
          <Link to={'https://relaxscofa.com/dr-yawn-bio/'} target="_blank" rel="noopener noreferrer">
            <img src={DRYawnTitle} alt="Logo" style={{ maxWidth: 115 }} className="img-fluid w-100" />
          </Link>
        </div>
        <br />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className={`fullPage`}>
                <div className={`row text-center g-0 ${props.pagename === "signup" ? 'mt-0 d-none' : 'mt-4'}`}>
                  <div className="col-12">
                    <div className="logo mt-3 mb-4">
                      <img src={logo} alt="Logo" />
                    </div>
                  </div>
                </div>
                <div className={`${props.pagename === "forgot-password" ? 'w-100 mt-5' : (props.pagename !== "signup") && (props.pagename !== "login") ? 'mt-5' : (props.signup) ? 'mt-0' : 'mt-sm-5'} row mb-2 g-0`}>
                  <div className="col-xxl-6 col-xl-8 col-lg-8 col-md-10 mx-auto">
                    <div className={`${props.pagename} authFormWrapper`}>
                      <div className={!props.login && (props.signup) ? 'mb-5 text-center' : "authHeader"}>
                        {props.signup ? (
                          <p className="lightColor smallText fw-semibold text-uppercase m-0">
                            {t("auth.layout.registerLabel")}
                          </p>
                        ) : props.login && (<></>
                          // <p className="lightColor smallText fw-semibold text-uppercase m-0">
                          //   Login
                          // </p>
                        )}
                        {(props.signup) && <h2 className="authTitle">{t("auth.layout.welcomeTitle")}</h2>}
                      </div>
                      {props?.children}
                      <br />
                      {props.signup ? (
                        <p className="authPara position-relative mt-2 mb-5" style={{ zIndex: 999 }}>
                          {t("auth.layout.haveAccount")}{" "}
                          <Link to={"/login"} className="authParaLink">
                            {t("auth.layout.signIn")}
                          </Link>
                        </p>
                      ) : props.login && (
                        <p className="authPara mt-5">
                          {t("auth.layout.noAccount")}{" "}
                          <Link to={"/freetrial"} className="authParaLink">
                            {t("auth.layout.signUp")}
                          </Link>
                        </p>
                      )}
                      {props.signup && <div className="dr-yawn-signup-img-container text-center">
                        <img src={DRYawnFullBody} alt="Logo" className="img-fluid" />
                        <div className="dr-yawn-signup-content dr-yawn-content-text">
                          <img src={DRYawnTitle} alt="Logo" style={{ maxWidth: 75 }} className="img-fluid w-100" />
                          {/* <h4>Dr. Yawn</h4> */}
                          <span style={{ opacity: 0 }}>Scofa Mascot</span>
                        </div>
                      </div>}
                    </div>
                  </div>

                </div>
                <div className="row g-0 mb-4">
                  <div className="col-12">
                    <div className="authFooter">
                      {(props.signup || props.login) && (
                        <div className="authFooterLinks">
                          <Link to={"https://relaxscofa.com/terms-of-service/"}>{t("auth.layout.terms")}</Link>
                          <span>|</span>
                          <Link to={"https://relaxscofa.com/privacy-policy/"}>{t("auth.layout.privacy")}</Link>
                        </div>
                      )}
                      {/* <div className="appLinks">
                        <Link to={"#_"} className="appLink">
                          <img src={googlePlay} alt="Google Play" />
                        </Link>
                        <Link to={"#_"} className="appLink">
                          <img src={appStore} alt="App Store" />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AuthLayout;